module.exports = __webpack_public_path__ + "img/06.3291316d.png";